import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=17e4c3a5&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=17e4c3a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e4c3a5",
  null
  
)

export default component.exports